var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form-row',{attrs:{"title":"Is this a Cash Purchase?"}},[_c('div',{staticClass:"flex flex-1 items-center"},[_c('input-radio-boolean',{attrs:{"name":"is_cash_purchase","true":"Yes","false":"No","read_only":_vm.read_only},model:{value:(_vm.is_cash_purchase),callback:function ($$v) {_vm.is_cash_purchase=$$v},expression:"is_cash_purchase"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }